import { defineMessages } from "react-intl";
const messages = defineMessages({
    billingOptionAnnually: {
        id: "app.admin.aiDiscoverability.reportTypes.billingSelector.annually",
        defaultMessage: "Annually",
    },
    billingOptionMonthly: {
        id: "app.admin.aiDiscoverability.reportTypes.billingSelector.monthly",
        defaultMessage: "Monthly",
    },
    billingOptionDiscount: {
        id: "app.admin.aiDiscoverability.reportTypes.billingSelector.discount",
        defaultMessage: "{discount}% Off",
    },
});
export default messages;
